import React, { useEffect, useState } from 'react';
import { getAllFeedbacks, getAllExaminerFeedbacks, getSharedStudentFeedback } from '../../services/feedbackService';
import { Link } from "react-router-dom";
import "./datatable.scss";
import { DataGrid } from '@mui/x-data-grid';
import { Collapse, Box } from '@mui/material';
import {useLocation } from "react-router-dom";

export const StudentFeedback = () => {
  const examinerId = parseInt(localStorage.getItem('examinerId'), 10);
  const studentId = parseInt(localStorage.getItem('studentId'), 10);
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
const location = useLocation();
  const fetchFeedbacks = async () => {
    try {
      let data;
      if (examinerId)
        data = await getAllExaminerFeedbacks(examinerId);
      else if (studentId)
        data = await getSharedStudentFeedback(studentId, true);
      else
        data = await getAllFeedbacks();
      setFeedbacks(data.data);
     // console.log("Fetched feedbacks:", data.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const toggleRowExpansion = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const formatColumnData = (value) => {
    if (!value) return value;
    let result = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    result = result.charAt(0).toUpperCase() + result.slice(1);
    return result;
  };

  const transformColumnData = (rows) => {
    return rows.map(row => ({
      ...row,
      type: formatColumnData(row.type)
    }));
  };

  const transformedRows = transformColumnData(feedbacks);

  const handleLinkClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const columns = [
    { field: 'reportType', headerName: 'Report Type', width: 200 },
    {
      field: 'termType',
      headerName: 'Submission Type',
      width: 200},
      
  {
    field: "thesisStatusId", headerName: "Files", width: 200,
    renderCell: (params) => {
      const {thesisStatusId } = params.row;
      return (
        <div className="cellAction">
          {(
            <div className="viewButton">
              <Link to={{ pathname: `/student/view-submission/${thesisStatusId}` }} style={{ textDecoration: "none" }}>
                View
              </Link> 
             
            </div>
          )}
          

        </div>
      );
    }
  },


    {
      field: 'finalFeedback',
      headerName: 'Feedback',
      width: 200,
      renderCell: (params) => {
        const row = params.row;
        const isExpanded = expandedRow === row.thesisStatusId;
        return (
          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "80px" }}>
              {row.finalFeedback ? row.finalFeedback.slice(0, 10) + "..." : "-"}
            </span>
            <button
              onClick={() => toggleRowExpansion(row.thesisStatusId)}
              style={{
                backgroundColor: isExpanded ? "#d32f2f" : "#1976d2",
                color: "white",
                border: "none",
                borderRadius: "6px",
                padding: "3px 8px",
                cursor: "pointer",
                fontSize: "0.8rem",
              }}
            >
              {isExpanded ? "Hide" : "Show"}
            </button>
          </Box>
        );
      },
    },
    {
      field: 'nextActionPoints',
      headerName: 'Next Action Points',
      width: 200,
      renderCell: (params) => {
        const row = params.row;
        const isExpanded = expandedRow === `${row.thesisStatusId}-actionPoints`;
        if (!row.nextActionPoints) {
          return <span>-</span>;
        }
        return (
          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "80px" }}>
              {row.nextActionPoints.slice(0, 10) + "..."}
            </span>
            <button
              onClick={() => toggleRowExpansion(`${row.thesisStatusId}-actionPoints`)}
              style={{
                backgroundColor: isExpanded ? "#d32f2f" : "#1976d2",
                color: "white",
                border: "none",
                borderRadius: "6px",
                padding: "3px 8px",
                cursor: "pointer",
                fontSize: "0.8rem",
              }}
            >
              {isExpanded ? "Hide" : "Show"}
            </button>
          </Box>
        );
      },
    },
    {
      field: 'resubmissionDeadline',
      headerName: 'Resubmission Deadline',
      width: 180,
      renderCell: (params) => (
        <span>{params.row.resubmissionDeadline || "-"}</span>
      ),
    }
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
          <div className="datatable" >
            <DataGrid 
            rows={transformedRows}
            getRowId={(row) => row.thesisStatusId}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[5, 10]}
            //checkboxSelection
          />
          <Collapse in={!!expandedRow} timeout="auto" unmountOnExit>
          {expandedRow && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                backgroundColor: "#f9f9f9",
                border: "1px solid #ddd",
                borderRadius: "8px",
                fontSize: "0.95rem",
                lineHeight: 1.6,
                whiteSpace: "pre-wrap",
              }}
            >
              {(() => {
                const isActionPoints = typeof expandedRow === "string" && expandedRow.endsWith("-actionPoints");
                const rowId = isActionPoints
                  ? Number(expandedRow.replace("-actionPoints", ""))
                  : expandedRow;
                const selectedRow = feedbacks.find(
                  (fb) => fb.thesisStatusId === rowId
                );
                if (!selectedRow) return null;

                return isActionPoints ? (
                  <>
                    <h4 style={{ marginTop: 0 }}>Next Action Points</h4>
                    <p>{selectedRow.nextActionPoints || "No action points available."}</p>
                  </>
                ) : (
                  <>
                    <h4 style={{ marginTop: 0 }}>Final Feedback</h4>
                    <p>{selectedRow.finalFeedback || "No feedback available."}</p>
                  </>
                );
              })()}
            </Box>
          )}
        </Collapse>

        </div>
      );
};
